<div class="row m-0">

  <ng-container >
    <div class="col-md-3 mt-2">
      <div class="car-image">
        <img class="img-fluid" [src]="bookedVehicle.vehicleImage" [alt]="vehicle.vehicleName">
      </div>
    </div>
    <div class="col-md-6  mt-2">
      <div class="d-flex">
        <div class="vehicle-name mr-auto">
          {{vehicle.vehicleName}}
        </div>
        <div class="vehicle-top-list  d-flex align-items-top">
          <div class="vehicle-class">
            {{vehicle.vehicleClass}}
          </div>
        </div>
      </div>



      <div class="vehicle-features">
        <div class="row mt-2">
          <!-- vehicle Gear Type-->
          <div class="col-md-6   mb-1  col-6 d-flex  align-items-top">
            <span>
              <mat-icon matTooltip="{{ 'GearType' | translate }}" matTooltipPosition="above"
                class="custom-icon gear-icon-modal mr-1" svgIcon="car-gear"></mat-icon>
            </span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{vehicle.vehicleGearType}}</li>
              </ul>
            </div>
          </div>

          <!-- vehicle Condition Unit -->
          <div class="col-md-6 mb-1  col-6 d-flex align-items-top">
            <span>
              <mat-icon matTooltip="{{ 'ACUnit' | translate }}" matTooltipPosition="above" class="fa-s mr-1">ac_unit
              </mat-icon>
            </span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{vehicle.hasAirConditions?'Yes':'No'}}</li>
              </ul>
            </div>
          </div>

          <!-- vehicle Petrol Type -->
          <div class="col-md-6  mb-1  col-6  d-flex align-items-top">
            <span>
              <fa-icon class="mr-1" matTooltip="{{ 'FuelType' | translate }}" matTooltipPosition="above"
                [icon]="faGasPump"></fa-icon>
            </span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{vehicle.vehiclePetrolType}}</li>
              </ul>
            </div>
          </div>

          <!-- vehicle Passengers Number -->
          <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
            <span>
              <fa-icon class="mr-1" matTooltip="{{ 'Passengers' | translate }}" matTooltipPosition="above"
                [icon]="faUser"></fa-icon>
            </span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{vehicle.vehiclePassengersNumber}}</li>
              </ul>
            </div>
          </div>

          <!-- vehicle Doors Number -->
          <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
            <span>
              <mat-icon matTooltip="{{ 'Doors' | translate }}" matTooltipPosition="above" class="custom-icon gear-icon-modal mr-1"
                svgIcon="car-door"></mat-icon>
            </span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{vehicle.vehicleDoorsNumber}}</li>
              </ul>
            </div>
          </div>

          <!-- vehicle Storage -->
          <div class="col-md-6  mb-1   col-6 d-flex align-items-top">
            <span>
              <mat-icon matTooltip="{{ 'Luggage' | translate }}" matTooltipPosition="above"
                class="fa-s luggage mr-1">luggage</mat-icon>
            </span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{vehicle.vehicleStorage}}</li>
              </ul>
            </div>
          </div>

          <!-- vehicle Number -->
          <div class="col-md-6   mb-1  col-6 d-flex align-items-top">
            <span>
              <fa-icon matTooltip="{{ 'PlateNumber' | translate }}" matTooltipPosition="above"
                class="mr-1 vehicleNumber" [icon]="faCar"></fa-icon>
            </span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{vehicle.plateNumber}}</li>
              </ul>
            </div>
          </div>

          <!-- vehicle Odometer -->
          <div class="col-md-6  mb-1 col-6 d-flex align-items-top">
            <span>
              <fa-icon matTooltip="{{ 'Odometer' | translate }}" matTooltipPosition="above" class="mr-1 faRoad"
                [icon]="faRoad"></fa-icon>
            </span>
            <div>
              <ul class="vehicle-inner-list">
                <li>{{vehicle.vehicleOdometer}}</li>
              </ul>
            </div>
          </div>
        </div>

        <!-- vehicle Location -->
        <div class="row mb-2 ">
          <div class="col-md-12 location-line d-flex align-items-top">
            <fa-icon class="mr-1 fa-s" [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}
          </div>
        </div>
      </div>

    </div>
  </ng-container>


</div>
